import PropTypes from 'prop-types';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, ModalContainer, ModalHeader, ModalContent, ModalBottom } from '~/components/modal';
import service from '~/services/kitchenDepartmentService'
import * as KitchenDepartmentsAction from '../../actions/formActions/kitchenDepartmentSelection';
import {toggleAllKitchenDepartmentSelection} from '~/actions/formActions/kitchenDepartmentSelection';

function mapDispatchToProp(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({},KitchenDepartmentsAction), dispatch),
    toggleAllKitchenDepartmentSelection: bindActionCreators(
    toggleAllKitchenDepartmentSelection, dispatch)
  };
 }

 function mapStateToProps(state, props) {
   let {forms: {kitchenDepartmentSelection}} = state;
   return { kitchenDepartmentSelection };
  }

@connect(mapStateToProps, mapDispatchToProp)
export default class SelectDepartment extends Modal {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    all: PropTypes.array.isRequired,
    closeKitchenDepartmentSelection: PropTypes.func.isRequired,
    toggleKitchenDepartmentSelection: PropTypes.func.isRequired,
    toggleAllKitchenDepartmentSelection: PropTypes.func.isRequired,
    submitKitchenDepartmentSelection: PropTypes.func.isRequired,
  };
  static contextTypes = {
      currentStore: PropTypes.object.isRequired
  };

  constructor(props) {
      super(props);
      this.toggleAll = this.toggleAll.bind(this);
      this.state = {
        departments: [],
      }
  }

  componentDidMount() {
    this.getAll()
  }

  async getAll(){
    let kdPath = `v2/stores/${this.context.currentStore.id}/kitchen_departments`
    let response = await service.get(kdPath, {per_page:999999})
    let kitchen_department =  response.data.map(({kitchen_department})=>kitchen_department)
    this.props.actions.getAllKitchenDepartments(kitchen_department)
  }

  // async fetchDepartments(){
  //   let { departments }= await service.getAllWithPrinter(this.context.currentStore.id)
  //   this.props.actions.getAllKitchenDepartments(departments)
  // }

  toggleAll(event) {
     this.props.all.map((data)=>{
         data.checked=event.target.checked;
     });
     this.props.toggleAllKitchenDepartmentSelection(!event.target.checked);
   }

  renderChildren(){
    const {
      closeKitchenDepartmentSelection,
      toggleKitchenDepartmentSelection,
      submitKitchenDepartmentSelection,
      kitchenDepartmentSelection
    } = this.props;
    let customerHeader = this.props.customerHeader? this.props.customerHeader(): null;
    return (
      <ModalContainer >
        <ModalHeader title="Select Kitchen Departments">
            { customerHeader }
            <div>
                <input type="checkbox" onChange={ this.toggleAll }/>
                <span className="all-nodes-label">All Kitchen Departments</span>
            </div>
        </ModalHeader>
        <ModalContent>
          <div>
            <table>
              <thead>
                  <tr>
                      <th style={ { width: '20%' } }/>
                      <th style={ { width: '80%' } }>KitchenDepartments</th>
                  </tr>
              </thead>
              <tbody>
                {kitchenDepartmentSelection.all.map((v) => {
                  return (
                    <tr key={v.kitchen_department_id}>
                      <td>
                        <input
                        type="checkbox"
                        checked={v.checked}
                        onChange={ (e) => {toggleKitchenDepartmentSelection(v.kitchen_department_id,e.target.checked)} }
                        />
                      </td>
                      <td>{v.kitchen_department_name}</td>
                    </tr>)
                })}
              </tbody>
           </table>
          </div>
        </ModalContent>
        <ModalBottom>
          <button className="btn btn-secondary"
                  onClick={ closeKitchenDepartmentSelection }>Cancel</button>
          <button className="btn btn-primary"
                  onClick={ submitKitchenDepartmentSelection }>Save</button>
        </ModalBottom>
      </ModalContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/components/select-kitchen-department/selectKitchenDepartment.js
 **/